<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<div class="content min-vh-100 flex-column d-flex justify-content-between">
					<section>
						<h2 class="title">
							<img src="/img/ico-mins-personal-accident.svg" />{{ title }}
						</h2>
						<p>
							<b>{{ intro }}</b>
						</p>
						<div class="accordion" role="tablist">
							<b-card v-for="(coverage, coverage_key) in coverages" :key="coverage_key" no-body class="mb-1">
								<div class="card-header">
									<h6>
										<button v-b-toggle="'coverage-'+coverage_key" class="btn btn-link collapsed" type="button">
											{{ coverage.title }}
										</button>
									</h6>
								</div>
								<b-collapse :id="'coverage-'+coverage_key" accordion="my-accordion" role="tabpanel">
									<b-card-body v-for="(chapter, chapter_key) in coverage.chapters" :key="chapter_key">
										<b-card-title>{{ chapter.title }}</b-card-title>
										<b-card-text v-html="chapter.text"></b-card-text>
										<b-card-sub-title>LIMIT</b-card-sub-title>
										<b-card-text v-html="chapter.limit || '-'"></b-card-text>
									</b-card-body>
								</b-collapse>
							</b-card>
						</div>
					</section>
					<ReadAllTermsAndConditions/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ReadAllTermsAndConditions from '@/components/ReadAllTermsAndConditions.vue'

export default {
	components: {
		ReadAllTermsAndConditions,
	},
	data(){
		return {
			title: "TRAVEL/FLIGHT ACCIDENT",
			intro: "The Company provides accident coverage suffered by the insured during the Travel period, sustained during professional and non-professional activities, and communicated to the Company.",
			coverages: [
				{
					title: "ACCIDENTAL DEATH OR PERMANENT DISABILITY",
					chapters: [
						{
							title: "",
							text: "The Company insures (non-aerial) Injuries suffered by the Insured Party during the period of the Trip, that within two years of the date they occur, have the direct consequence of death or Permanent Disability.",
							limit: "€ 250.000 for Claim and insurance period. In the case of Injury deriving from public riots or acts of terrorism, vandalism or attacks, the Limit of Liability is increased by 50%."
						},
					]
				},
				{
					title: "INJURY IN FLIGHT",
					chapters: [
						{
							title: "",
							text: "The Company provides insurance, from the moment the Insured Party boards an airplane/helicopter until the time they have exited, against Injuries that the Party suffers as a passenger on commercial and charter flights (excluding private airplanes), and that within two years of the date they occur, have the direct consequence of death or Permanent Disability.",
							limit: "€ 250.000  With a sub-limit of € 5.000.000 per airplane/helicopter"
						},
					]
				},
				{
					title: "COMA RESULTING FROM INJURY",
					chapters: [
						{
							//title: "",
							text: "In the case of coma resulting from an insured Injury, for more than ten consecutive days.",
							limit: "€ 75 per day for a maximum of 365 consecutive days"
						},
					]
				},
				{
					title: "REIMBURSEMENT OF EXPENSES FOR PERMANENT DISABILITY DUE TO INJURY",
					chapters: [
						{
							title: "",
							text: "Following an Injury during Travel that entails permanent invalidity exceeding 25%, the Company shall reimburse the expenses sustained by the Insured Party to adapt their Residence or Domicile, the owned vehicle or the work area.",
							limit: "50.000 € per claim ed insurance period"
						}
					]
				},
				{
					title: "TEMPORARY INABILITY TO WORK",
					chapters: [
						{
							title: "",
							text: "In the event that the insured Injury is the cause of a temporary and total inability to work for at least 5 consecutive days, the Company will pay the agency chosen by the Insured Companies an amount equal to the gross compensation, based on the average gross compensation of the injured Insured Party in the previous 12 months.",
							limit: "Payment of gross revenues (based on average of past 12 months) max 120.000€ max 180 days"
						}
					]
				},
			]
		}
	}
}
</script>
